// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"Sidebar_sidebarWrapper__VaYIv","detailsMode":"Sidebar_detailsMode__85vLJ"};